module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "fmt02"
    }
  }, [_c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("A WORD ON THE ORTHOGRAPHY AND PRONUNCIATION")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Malagasy language has dialectical variation throughout the island. In the book, Malagasy words reflect either the standard Merina spelling (“official Malagasy”) or the Betsimisaraka pronunciation, depending on the context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Merina dialect, the letter "), _c('i', [_vm._v("o")]), _vm._v(" is pronounced like the English "), _c('i', [_vm._v("oo")]), _vm._v(" (as in “zoom”). In the northern Betsimisaraka dialect, "), _c('i', [_vm._v("o")]), _vm._v(" is frequently pronounced long (as in the English “oh”). When I cite a Betsimisaraka speaker, I use the diacritical "), _c('i', [_vm._v("ô.")]), _vm._v(" Thus the Merina word "), _c('i', [_vm._v("vola")]), _vm._v(" (money) becomes "), _c('i', [_vm._v("vôla")]), _vm._v(" in Betsimisaraka, for example.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Merina, the letter "), _c('i', [_vm._v("n")]), _vm._v(" is pronounced as in English, but the Betsimisaraka dialect frequently employs the velar nasal (the "), _c('i', [_vm._v("ng")]), _vm._v(" sound in “sing”) where Merina does not. The velar nasal is conventionally written as "), _c('i', [_vm._v("ñ")]), _vm._v(" in the ethnographic literature of Madagascar. Thus "), _c('i', [_vm._v("razana")]), _vm._v(" (ancestor) in Merina becomes "), _c('i', [_vm._v("razaña")]), _vm._v(" in Betsimisaraka.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When citing the work of other Madagascar scholars, I copy the spelling they use for Malagasy vocabulary.")])])]), _c('a', {
    attrs: {
      "id": "fmt02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 81
// module chunks = 0